$(document).ready(function () {
  KlaviyoSubscribe.attachToForms('#footer-mailing', {
    hide_form_on_success: false,
  })

  KlaviyoSubscribe.attachToForms('#notified-form', {
    hide_form_on_success: true,
  })
})
